import React from "react";
import PropTypes from "prop-types";

import AuthorLink from "cards/components/AuthorLink";
import { MicrodataContext } from "config/contexts";

export default function Byline({ authors }) {
  return (
    <MicrodataContext.Consumer>
      {microdata => (
        <React.Fragment>
          {authors.map((author, index, arr) => {
            const authorName = `${author.display_name}${
              index < arr.length - 1 ? ", " : ""
            }`;

            return microdata ? (
              <span
                key={author.username}
                itemProp="author"
                itemScope
                itemType="http://schema.org/Person"
              >
                <AuthorLink username={author.username} itemProp="url">
                  <span itemProp="name">{authorName}</span>
                </AuthorLink>
              </span>
            ) : (
              <AuthorLink key={author.username} username={author.username}>
                {authorName}
              </AuthorLink>
            );
          })}
        </React.Fragment>
      )}
    </MicrodataContext.Consumer>
  );
}

Byline.propTypes = {
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      username: PropTypes.string.isRequired,
      display_name: PropTypes.string.isRequired,
    })
  ).isRequired,
};
